import { apiClient } from './client';
import { Customer } from '../../pages/customers/types';

export const customersApi = {
    getAll: async (): Promise<Customer[]> => {
        const res = await apiClient.get('/admin/users');
        return res.data.data.map((u: any) => {
            const sub = u.subscriptions?.[0];
            const transformedSub = sub ? {
                ...sub,
                plan: sub.variant?.product ? {
                    name: sub.variant.product.name,
                    prices: sub.price ? [sub.price] : []
                } : undefined
            } : undefined;

            return {
                ...u,
                subscription: transformedSub
            };
        });
    },

    getById: async (id: string): Promise<Customer> => {
        const res = await apiClient.get(`/admin/users/${id}`);
        const user = res.data.data;

        const transformSub = (sub: any) => {
            if (!sub) return undefined;
            return {
                ...sub,
                plan: sub.variant?.product ? {
                    name: sub.variant.product.name,
                    prices: sub.price ? [sub.price] : []
                } : undefined
            };
        };

        return {
            ...user,
            subscription: transformSub(user.subscriptions?.[0]),
            subscriptions: user.subscriptions?.map(transformSub)
        };
    },

    update: async (id: string, data: Partial<Customer>): Promise<Customer> => {
        const res = await apiClient.put(`/admin/users/${id}`, data);
        return res.data.data;
    },

    delete: async (id: string): Promise<void> => {
        await apiClient.delete(`/admin/users/${id}`);
    },

    ban: async (id: string): Promise<Customer> => {
        const res = await apiClient.patch(`/admin/users/${id}/ban`);
        return res.data.data;
    },

    unban: async (id: string): Promise<Customer> => {
        const res = await apiClient.patch(`/admin/users/${id}/unban`);
        return res.data.data;
    },

    remove: async (id: string): Promise<void> => {
        await apiClient.delete(`/admin/users/${id}`);
    }
};
